import { jsx } from 'react/jsx-runtime';
import { FeatureURI } from '@sbt-web/network/types';
import { Badge } from '@sbt-web/ui';
import styles from './index.module.css.js';

const PromoBadge = ({ item }) => {
    const promotions = item?.features[FeatureURI.Promotions];
    const hasActivePromotions = Object.keys(promotions ?? {}).length > 0;
    if (!hasActivePromotions)
        return null;
    return (jsx(Badge, { classes: [styles.promoBadge], flavor: "small", rounded: true, children: "Promo" }));
};

export { PromoBadge };
//# sourceMappingURL=index.js.map
